import { useEffect, useState, useCallback, useRef } from 'react';
import { toast } from 'react-toastify';

import config from '../../config';

import '../../styles/popup.css';

import TextField from '@mui/material/TextField';

const AddAddressForm = ({ onNext, setSubmitHandler }) => {
    const [formData, setFormData] = useState({
        streetNumber: '',
        street: '',
        city: '',
        state: '',
        postalCode: '',
        country: '',
    });
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const formDataRef = useRef(formData);
    useEffect(() => {
        formDataRef.current = formData;
    }, [formData]);

    const handleSubmit = useCallback(async () => {
        setError('');
        try {
            const response = await fetch(`${config.API_URL}/v2/address`, {
                method: 'POST',
                headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}`, 'Content-Type': 'application/json' },
                body: JSON.stringify(formDataRef.current),
            });

            const data = await response.json();
            console.log("API Response:", data);

            if (response.status === 409) {
                setError('Address already exists.');
                console.log("Existing Address ID:", data._id);
                return false;
            } else if (!response.ok) {
                toast.error('Failed to create address. Please try again.');
                setError('Error creating address.');
                return false;
            } else if (!data._id) {
                toast.error("Invalid address data.");
                setError("Please fill in all required fields.");
                return false;
            } else {
                console.log("New Address Created, ID:", data._id);
                toast.success('Address created successfully!');
                onNext(data._id);
                return true;
            }
        } catch (err) {
            console.error("Fetch Error:", err);
            setError('An unexpected error occurred.');
            return false;
        }
    }, [onNext]);

    useEffect(() => {
        if (setSubmitHandler) setSubmitHandler(() => handleSubmit);
    }, [setSubmitHandler, handleSubmit]);

    return (
        <>
            <TextField
                label="Country"
                name="country"
                variant="outlined"
                fullWidth
                value={formData.country}
                onChange={handleChange}
                sx={{ marginBottom: '1rem' }}
                required
            />
            <TextField
                label="State"
                name="state"
                variant="outlined"
                fullWidth
                value={formData.state}
                onChange={handleChange}
                sx={{ marginBottom: '1rem' }}
                required
            />
            <div className="popup-columns">
                <TextField
                    label="City"
                    name="city"
                    variant="outlined"
                    fullWidth
                    value={formData.city}
                    onChange={handleChange}
                    sx={{ marginBottom: '1rem' }}
                    required
                />
                <TextField
                    label="Postal Code"
                    name="postalCode"
                    variant="outlined"
                    fullWidth
                    value={formData.postalCode}
                    onChange={handleChange}
                    sx={{ width: '50%', marginBottom: '1rem' }}
                    required
                />
            </div>
            <div className="popup-columns">
                <TextField
                    label="Street"
                    name="street"
                    variant="outlined"
                    fullWidth
                    value={formData.street}
                    onChange={handleChange}
                    sx={{ marginBottom: '1rem' }}
                    required
                />
                <TextField
                    label="Street No."
                    name="streetNumber"
                    type="number"
                    variant="outlined"
                    fullWidth
                    value={formData.streetNumber}
                    onChange={handleChange}
                    sx={{ width: '50%', marginBottom: '1rem' }}
                    required
                />
            </div>
            {error && <p className="error-text w-full font-poppins text-center text-[#FF0000]">{error}</p>}
        </>
    );
};

export default AddAddressForm;
